// extracted by mini-css-extract-plugin
module.exports = {"form":"PricingListResult_form__3r2qq","metricBox":"PricingListResult_metricBox__20p0c","strike":"PricingListResult_strike__RtVnH"};